import { render, staticRenderFns } from "./quickABIcon.vue?vue&type=template&id=fbd70db2&"
import script from "./quickABIcon.vue?vue&type=script&lang=js&"
export * from "./quickABIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports